import type { BusinessDataType } from '../context/BusinessContext'
import type { FilterType } from '../context/CommonContext'

//* Extrai as opções de empresas (únicas, ordenadas) a partir dos negócios carregados
export const extractCompanyOptions = (data: BusinessDataType): FilterType[] => {
    const companies = new Map<number, FilterType>()

    for (const pipeline of data.pipelines) {
        for (const step of pipeline.steps) {
            for (const business of step.business) {
                if (business.company) {
                    companies.set(Number(business.company.id), {
                        id: Number(business.company.id),
                        label: business.company.name
                    })
                }
            }
        }
    }

    return Array.from(companies.values()).sort((a, b) => a.label.localeCompare(b.label))
}
